module.exports = __webpack_public_path__ + "static/cer_dor_7-f456e18517224793120c2daf6ae7b35b.jpg";